
export default class Task {

  constructor({ item, attributes }) {

    this.item = item;
    this.attributes = attributes;
    this.initialAttributes = null;
    this.deltas = {};
    this.currentItem = null;
    // this.easing = 'linear';
  }

  setCurrentItem(currentItem) {
    this.currentItem = currentItem;
  }

  update(fraction) {
    if (!this.initialAttributes) {
      this.initialAttributes = { ...this.currentItem.attributes };
      Object.keys(this.attributes).forEach(key => {
        this.deltas[key] = this.attributes[key] - this.initialAttributes[key];
      });
      console.log('deltas', JSON.stringify(this.deltas));
    }
    const nextAttributes = {};
    Object.keys(this.attributes).forEach(key => {
      nextAttributes[key] = this.initialAttributes[key] + this.deltas[key] * fraction;
    });
    return this.currentItem.update(nextAttributes);
  }
}